<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        05.31
        <br />2016
      </span>
      <span class="tiel">京交会刘传军：美菜网助力疏解非首都功能</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/63b20f2fd873458e04ff598a8134b5bd.jpg"
          width="640"
        />
      </p>
      <div class="tet-js">
        5月30日，美菜创始人、CEO刘传军作为嘉宾出席了由北京市商务委员会、北京日报报业集团联合主办的“2016中国（北京）电子商务大会”，并作出以《农业电商对城市基因的重构》为主题的演讲，旨在“改变中国农业，助力疏散非首都功能”。
        <br />
        <br />本届京交会以“创新·生态·共享”为主题，突出高端化、国际化和专业化。来自京东、阿里巴巴、苏宁、国美等国内知名电子商务、互联网企业负责人等50余位嘉宾进行主题演讲，畅谈未来电子商务市场的新机遇和新动能。
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>一群有着极度农业情怀的平凡人，在做一件非凡的事情
      </div>
      <div
        class="tet-js"
      >美菜网CEO刘传军从前是一位地地道道的农民，对土地有着不一样的感情，他常挂在嘴边的话是对农民的责任和对改变农民生活的情怀。“2015年的国庆，我回到老家，发现当时玉米的价格一斤只卖9毛钱，而97年的时候玉米就已经卖到了8毛5分钱。近二十年物价上涨和通货膨胀却没有让农产品收购价有所提高，而种植成本相比二十年前已经有了显著性的提高。这让我感觉，农业需要一次变革”。刘传军说到：“供给侧两端的核心是生产和流通，而农业的生产和流通业也一样需要改革，而互联网带来了扁平化，借助科技的力量可以让农村变得更好”。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>对于美菜而言，农业互联网是什么?意味着什么?
      </div>
      <div
        class="tet-js"
      >刘传军表示：“纵观整个中国工业的发展，会发现，中国工业经历了外资进入——外贸出口——工业现代化三个阶段。但是从2014年开始，中国经济增长放缓，若想继续保持经济稳定增长，我个人判断：是农业，是农业现代化。而对于美菜而言，正好处于这样一个大背景下，正好处于这样一个时代浪潮之下。 ”</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜商业模式：砍掉中间商，连接农户和餐厅
      </div>
      <div
        class="tet-js"
      >美菜一端连接的是中国的8亿农民，因为中国的农业极度分散；一端连接的是中国近千万家的餐厅和社区的蔬菜、粮油、米面等的便利店的采购点。在没有美菜之前，餐厅和零售点的老板每天早上3点钟起床，骑着三轮车或者开辆面包车，不管狂风暴雨还是酷暑严寒都要去批发市场买1000多块钱的菜，不仅菜贵且不新鲜，又苦又累。有了美菜以后，餐店老板再也不用早起，头一天晚上躺在床上就可以把你需要的菜品在手机上下单，一觉睡到自然醒。第二天早上美菜会在客户需要的时间点把他需要的产品送到每一家门店，帮他搬到后厨的货架。美菜利用互联网B2B真正砍掉所有的中间环节，实现农户和餐厅的直接交付。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>让老百姓生活更简单，并为疏散非首都功能而助力
      </div>
      <div class="tet-js">
        习近平总书记在2015年2月10日的中央财经领导小组第九次会议上提出，要疏解北京“非首都功能”，一般性制造业、区域性物流基地、区域性批发市场、部分教育医疗四大非首都功能将被疏解。美菜的商业模式通过互联网缩短农产品流通环节，可以为疏散非首都的功能而助力：一方面通过加快整个农业的流通，缓解了交通的压力和区域性物流压力，并保障了食品的安全；另一方面通过降低商户供应链成本，减少供应链的劳动力。
        <br />
        <br />互联网经济与商业文化的大背景下，美菜将率先成为农村电商的践行者，不仅将改变中国几千年来传统农业的贫穷落后的现状，并助力于非首都功能疏解、为京津冀的协同发展注入新动力。我们相信：美菜模式，将改变中国！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
